
$(function () {

    //handles files removed
    $(".widget-file-upload").on(WidgetEvents.SIMPLE_LIST_REMOVE, function (e, data) {
        $(this).find("input[type=file]").filter(function (idx, element) {
            return $(this).data("file-name") === data.text;
        }).remove();
    });

    //handles the "Choose file" button click
    $(".widget-file-upload .btn[data-behavior=Choose]").click(function () {
        var defaultInput = $(this).parents(".widget-file-upload").find(".fu-inputs input").filter(function () {
            return $(this).data("file-name") == null;
        });

        if (defaultInput.length === 1) {
            defaultInput.click();
        }
    });

    //handles the "Clear" button click
    $(".widget-file-upload .btn[data-behavior=Clear]").click(function () {
        $(this).parents(".widget-file-upload").find("input[type=file]").remove();
        $(this).parents(".widget-file-upload .fu-inputs").prepend("<input type='file' name='Attachments' />");
    });

    //handles the file input change event
    $(".widget-file-upload").on("change", "input[type=file]", function (e) {
        if (Modernizr.filereader) {
            if (e.target.files.length > 0) {
                var file = e.target.files[0];
                var existingFile = $(this).parents(".widget-file-upload").find("input[type=file]")
                    .filter(function (idx, element) {
                        return $(this).data("file-name") === file.name;
                    });

                //return if that file has been already added
                if (existingFile.length > 0) return;

                var inputName = $(this).parents(".widget-file-upload").data("input-name");
                $(this).data("file-name", file.name).parent().append("<input type='file' name='" + inputName + "' />");

                $(this).parents(".widget-file-upload").trigger("stems.newFile", {
                    file: file,
                    text: file.name,
                    value: file.size.toString() + file.name
                });
            }
        }
        else {
            var inputName = $(this).parents(".widget-file-upload").data("input-name");
            $(this).parent().prepend("<input type='file' name='" + inputName + "' />");
        }
    });
})